export default {
  name: "SystemLayout",
  data() {
    return {
      isSidebarCollapsed: false,
      dropdowns: {
        store: false, //商家管理
        customer: false, //顧客管理
        order: false, //訂單管理
        employee: false, //員工管理
        setting: false, //系統管理
        table: false, //桌位管理
        report: false, //報表管理
        menu: false, //菜單管理
      },
    };
  },
  computed: {
    currentPath() {
      // 根據當前路由計算顯示的路徑名稱
      const route = this.$route.path;
      if (route === "/systemdashboard") return "儀表板";
      if (route === "/systemdashboard/store/info")
        return "商家管理 > 商家資訊設定";
      if (route === "/systemdashboard/store/hours")
        return "商家管理 > 營業時間設定";
      if (route === "/systemdashboard/store/tax") return "商家管理 > 稅金設定";
      if (route === "/systemdashboard/store/service")
        return "商家管理 > 服務費設定";
      if (route === "/systemdashboard/store/language")
        return "商家管理 > 語系與條別設定";
      if (route === "/systemdashboard/store/theme")
        return "商家管理 > POS主題與介面樣式";
      if (route === "/systemdashboard/store/type")
        return "商家管理 > 店舖類型與功能開關";
      if (route === "/systemdashboard/store/cloudorder")
        return "商家管理 > 雲端點餐設定";

      //菜單管理
      if (route === "/systemdashboard/menu/item")
        return "菜單管理 > 商品項目管理";
      if (route === "/systemdashboard/menu/itemaddons")
        return "菜單管理 > 商品加料管理";
      //員工管理
      if (route === "/systemdashboard/employee/account")
        return "員工管理 > 員工帳號管理";
      if (route === "/systemdashboard/employee/salary")
        return "員工管理 > 薪資計算";
      if (route === "/systemdashboard/employee/attendance")
        return "員工管理 > 打卡/出勤紀錄";
      //顧客管理
      if (route === "/systemdashboard/customer/info")
        return "顧客管理 > 顧客基本資料";
      if (route === "/systemdashboard/customer/coopon")
        return "顧客管理 > 儲值金/點數/優惠券";
      if (route === "/systemdashboard/customer/history")
        return "顧客管理 > 消費歷史紀錄";
      //訂單管理
      if (route === "/systemdashboard/order/list") return "訂單管理 > 訂單列表";
      // 桌位管理
      if (route === "/systemdashboard/table/class")
        return "桌位管理 > 桌區分類";
      if (route === "/systemdashboard/table/state")
        return "桌位管理 > 桌位狀態與開桌";
      if (route === "/systemdashboard/table/reserve")
        return "桌位管理 > 預約桌位設定";
      if (route === "/systemdashboard/table/auto")
        return "桌位管理 > 自動合併桌功能";
      if (route === "/systemdashboard/table/number")
        return "桌位管理 > 桌位設定";
      // 報表管理：依群組與目前頁籤顯示路徑名稱。
      if (route === "/systemdashboard/data/accounting") {
        const labels = {
          summary: "綜合營收",
          daily: "當日營業",
          todayTransactions: "今日逐筆帳",
          hourly: "時段帳",
          payment: "付款方式",
        };
        const tab = String(this.$route.query.tab || "summary");
        return `報表管理 > 營業帳務 > ${labels[tab] || labels.summary}`;
      }
      if (route === "/systemdashboard/data/analysis") {
        const labels = {
          orderType: "消費方式",
          product: "熱門商品／加料",
          tableUsage: "桌位使用率",
          tableStatus: "即時桌況",
        };
        const tab = String(this.$route.query.tab || "orderType");
        return `報表管理 > 營運分析 > ${labels[tab] || labels.orderType}`;
      }

      // 系統管理
      if (route === "/systemdashboard/set/print")return "系統管理 > 出單機設定";
      // if (route === "/systemdashboard/set/print")return "系統管理 > 出單機設定";
      // if (route === "/systemdashboard/set/print")return "系統管理 > 出單機設定";
      if (route === "/systemdashboard/set/api")return "系統管理 > API整合設定";
      if (route === "/systemdashboard/set/payment")return "系統管理 > 付款方式管理";

      if (route === "/systemdashboard/orders") return "訂單管理";
      if (route === "/systemdashboard/users") return "用戶管理";
      if (route === "/systemdashboard/settings") return "系統設定";
      if (route === "/systemdashboard/menu") return "菜單管理";
    },
    // 修改：只有在直接點擊商家管理時才高亮顯示，子項目不影響父項目
    isStoreManagementActive() {
      // 永遠返回 false，這樣商家管理標題就不會被高亮
      return false;
    },
  },
  methods: {
    goToMainConsole() {
      this.$router.push("/mainconsole"); // 導向主控台
    },
    toggleSidebar() {
      // 切換側邊欄狀態
      this.isSidebarCollapsed = !this.isSidebarCollapsed;

      // 儲存用戶對側邊欄的偏好設置到本地儲存
      localStorage.setItem("sidebarCollapsed", this.isSidebarCollapsed);

      // 避免事件衝突，停止事件冒泡
      event.stopPropagation();

      // 視窗大小調整延遲處理
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 300);
    },
    toggleDropdown(dropdown) {
      // 把所有 dropdown 關閉
      Object.keys(this.dropdowns).forEach((key) => {
        if (key !== dropdown) {
          this.dropdowns[key] = false; // 關閉非點擊的區塊
        }
      });

      // 切換點擊的區塊
      this.dropdowns[dropdown] = !this.dropdowns[dropdown];
    },

    isDropdownActive(name) {
      // 判斷是否正好點擊的是這個下拉選單的主項目，而不是子選單
      return this.$route.path === `/systemdashboard/${name}`;
    },
    // 檢查當前頁面是否為特定路徑
    isMenuActive(path) {
      // 儀表板僅在完全匹配路徑時才激活
      if (path === "/systemdashboard") {
        return this.$route.path === "/systemdashboard";
      }
      // 商家管理標題永遠不選中
      if (path === "/systemdashboard/store") {
        return false;
      }

      // === ✅ 修正重點：嚴格比對 path 或以 path + '/' 開頭 ===
      return (
        this.$route.path === path || this.$route.path.startsWith(path + "/")
      );
    },
  },
  created() {
    // 檢查螢幕寬度，自動折疊側邊欄
    const checkScreenWidth = () => {
      // 只在視窗寬度變小時自動折疊，不自動展開
      if (window.innerWidth <= 768) {
        this.isSidebarCollapsed = true;
      }
    };
    // 初始檢查
    checkScreenWidth();

    // 加載用戶對側邊欄的偏好設置（如果存在）
    const savedSidebarState = localStorage.getItem("sidebarCollapsed");
    if (savedSidebarState !== null && window.innerWidth > 768) {
      this.isSidebarCollapsed = savedSidebarState === "true";
    }

    // 監聽視窗大小變化
    window.addEventListener("resize", checkScreenWidth);

    // 如果頁面是商家管理子頁面，自動展開商家管理選單
    if (this.isStoreManagementActive) {
      this.isStoreDropdownOpen = true;
    }

    const path = this.$route.path;
    // 自動展開當前對應下拉選單
    if (path.includes("/systemdashboard/store")) {
      this.dropdowns.store = true;
    }
    if (path.includes("/systemdashboard/menu")) {
      this.dropdowns.menu = true;
    }
    if (path.includes("/systemdashboard/customer")) {
      this.dropdowns.customer = true;
    }
    if (path.includes("/systemdashboard/order")) {
      this.dropdowns.order = true;
    }
    if (path.includes("/systemdashboard/employee")) {
      this.dropdowns.employee = true;
    }
    if (this.$route.path.includes("/systemdashboard/settings")) {
      this.dropdowns.setting = true;
    }
    if (this.$route.path.includes("/systemdashboard/table")) {
      this.dropdowns.table = true;
    }
    if (this.$route.path.includes("/systemdashboard/report")) {
      this.dropdowns.report = true;
    }
  },
  beforeUnmount() {
    // 移除事件監聽
    window.removeEventListener("resize", this.checkScreenWidth);
  },
  watch: {
    // 監聽路由變化，自動展開/折疊相關選單
    $route(to) {
      // 如果導航到商家管理相關頁面，自動展開商家管理選單
      if (to.path.includes("/systemdashboard/store")) {
        this.isStoreDropdownOpen = true;
      }
    },
  },
};
